import { render, staticRenderFns } from "./build_sandbox_image.vue?vue&type=template&id=5dfc9d19&scoped=true&"
import script from "./build_sandbox_image.vue?vue&type=script&lang=ts&"
export * from "./build_sandbox_image.vue?vue&type=script&lang=ts&"
import style0 from "./build_sandbox_image.vue?vue&type=style&index=0&id=5dfc9d19&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfc9d19",
  null
  
)

export default component.exports